import React, { useState } from 'react';
import './App.css';
import DomainSelector from './components/DomainSelector';
import DomainTables from './components/DomainTables';
import QueryEditor from './components/QueryEditor';
import TableComparison from './components/TableComparison';
import EnvironmentToggle from './components/EnvironmentToggle';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

type TabType = 'domains' | 'query' | 'comparison';

function AppContent() {
  const [activeTab, setActiveTab] = useState<TabType>('domains');
  const [currentEnvironment, setCurrentEnvironment] = useState<string>('DEV');
  const [selectedDomain, setSelectedDomain] = useState<string>('rfv');
  const { user, logout, userRole } = useAuth();

  const handleEnvironmentChange = (environment: string) => {
    setCurrentEnvironment(environment);
  };

  const handleDomainChange = (domainId: string) => {
    setSelectedDomain(domainId);
  };

  const tabs = [
    { id: 'domains' as TabType, label: 'Domain Tables' },
    { id: 'query' as TabType, label: 'SQL Query Editor' },
    { id: 'comparison' as TabType, label: 'Environment Comparison' }
  ];

  return (
    <div className="App">
      <header className={`App-header ${currentEnvironment === 'PROD' ? 'prod-environment' : ''}`}>
        <h1>DB Table Management</h1>
        <div className="header-controls">
          {(activeTab === 'domains' || activeTab === 'comparison') && (
            <DomainSelector
              currentDomain={selectedDomain}
              onDomainChange={handleDomainChange}
            />
          )}
          <EnvironmentToggle onEnvironmentChange={handleEnvironmentChange} />
          <div style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
              <span style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>{user?.name}</span>
              <span style={{ color: '#b8daff', fontSize: '12px', fontStyle: 'italic' }}>{userRole}</span>
            </div>
            <button
              onClick={logout}
              style={{
                padding: '8px 16px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <nav className="tab-navigation">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="tab-content">
          {activeTab === 'domains' && (
            <DomainTables
              domainId={selectedDomain}
              currentEnvironment={currentEnvironment}
            />
          )}
          {activeTab === 'query' && (
            <QueryEditor />
          )}
          {activeTab === 'comparison' && (
            <TableComparison domainId={selectedDomain} />
          )}
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <AppContent />
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
